export interface PlanillaPartidoOficialMesaNoRegsitradoJSON {
  ppomnr_id: string | null;
  ppomnr_ppid: string;
  ppomnr_eqid: number;
  ppomnr_nombre: string;
  ppomnr_apellido: string;
  ppomnr_dni: string;
  __delete: boolean;
}

export class PlanillaPartidoOficialMesaNoRegsitrado {
  protected constructor(
    private id: string | null,
    private ppid: string,
    private eqid: number,
    private nombre: string,
    private apellido: string,
    private dni: string,
    private __delete: boolean
  ) {}

  static createFrom(
    id: string | null,
    ppid: string,
    eqid: number,
    nombre: string,
    apellido: string,
    dni: string,
    __delete: boolean
  ) {
    return new this(id, ppid, eqid, nombre, apellido, dni, __delete);
  }

  static createForPlanilla(eqId: number, nombre: string, apellido: string, dni: string, __delete: boolean) {
    return PlanillaPartidoOficialMesaNoRegsitrado.createFrom('', '', eqId, nombre, apellido, dni, __delete);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: PlanillaPartidoOficialMesaNoRegsitrado) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: PlanillaPartidoOficialMesaNoRegsitradoJSON) {
    return PlanillaPartidoOficialMesaNoRegsitrado.createFrom(
      entity.ppomnr_id,
      entity.ppomnr_ppid,
      entity.ppomnr_eqid,
      entity.ppomnr_nombre,
      entity.ppomnr_apellido,
      entity.ppomnr_dni,
      entity.__delete
    );
  }

  toJSON(): PlanillaPartidoOficialMesaNoRegsitradoJSON {
    return {
      ppomnr_id: this.getId(),
      ppomnr_ppid: this.getPpid(),
      ppomnr_eqid: this.getEqid(),
      ppomnr_nombre: this.getNombre(),
      ppomnr_apellido: this.getApellido(),
      ppomnr_dni: this.getDni(),
      __delete: this.__delete,
    };
  }

  isActive(): boolean {
    return !this.__delete;
  }
  getId(): string | null {
    return this.id;
  }

  getPpid(): string {
    return this.ppid;
  }

  getEqid(): number {
    return this.eqid;
  }

  getNombre(): string {
    return this.nombre;
  }

  getApellido(): string {
    return this.apellido;
  }

  getDni(): string {
    return this.dni;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setPpid(value: string): void {
    this.ppid = value;
  }

  setEqid(value: number): void {
    this.eqid = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setApellido(value: string): void {
    this.apellido = value;
  }

  setDni(value: string): void {
    this.dni = value;
  }
  setDeleted(d: boolean) {
    this.__delete = d;
  }
}
